const resource = {
  translation: {
    connectWallet: '지갑 연결',
    title: 'BiFi 토큰과 GBiFi 토큰은 언제든지 Swap 가능합니다.',
    form: {
      amount: {
        title: '{{symbol}} 액수',
        balance: '지갑 잔액',
        placeholder: '{{amount}} {{symbol}} 이상부터 Swap 할 수 있습니다'
      },
      approve: '토큰 승인',
      registerToken: '토큰 추가',
      swap: 'Swap',
      error: {
        allowance: '⚠️ 토큰 지출한도 부족. 다시 토큰을 승인하여, 메타마스크에서 권한 편집에서 지출 한도를 올려주세요.'
      },
      initializing: '로딩중...'
    },
    description: ''
  }
};

export default resource;
